<!-- <div>
  <app-nested-header-notice></app-nested-header-notice>
</div> -->
<nav class="navbar navbar-expand-lg bg-dark" id="target" #target data-bs-theme="dark">
  <!-- Logo -->
  <a (click)="scroll(target)" class="navbar-brand" queryParamsHandling="merge" routerLink="/">
    <img ngSrc="assets/images/header/VeEX_logo_tagline_reversed.png" alt="VeEX Inc." id="logo-image" width="1259"
      height="572">
  </a>
  <button id="togglenav" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#veexNavbar"
    aria-controls="veexNavbar" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="veexNavbar">
    <!-- Left Side -->
    <ul class="navbar-nav me-auto" role="tablist">
      <li class="nav-item" role="presentation" [attr.data-bs-toggle]="isMobile ? 'collapse' : null"
        [attr.data-bs-target]="isMobile ? '#veexNavbar' : null">
        <button role="tab" type="button" class="header-button" data-bs-toggle="modal" data-bs-target="#productsModal">
          <span class="nav-link mainlink">{{ 'HEADER.PRODUCTS' | translate }}</span>
        </button>
      </li>
      <li class="nav-item" role="presentation" [attr.data-bs-toggle]="isMobile ? 'collapse' : null"
        [attr.data-bs-target]="isMobile ? '#veexNavbar' : null">
        <button role="tab" type="button" class="header-button" data-bs-toggle="modal" data-bs-target="#solutionsModal">
          <span class="nav-link mainlink" (click)="getmicrositeURL();">{{ 'HEADER.SOLUTIONS' | translate }}</span>
        </button>
      </li>
      <li class="nav-item" role="presentation" [attr.data-bs-toggle]="isMobile ? 'collapse' : null"
        [attr.data-bs-target]="isMobile ? '#veexNavbar' : null">
        <button role="tab" type="button" class="header-button" data-bs-toggle="modal" data-bs-target="#supportModal">
          <span class="nav-link mainlink">{{ 'HEADER.SUPPORT' | translate }}</span>
        </button>
      </li>
      <li class="nav-item" role="presentation" [attr.data-bs-toggle]="isMobile ? 'collapse' : null"
        [attr.data-bs-target]="isMobile ? '#veexNavbar' : null">
        <button role="tab" type="button" class="header-button" data-bs-toggle="modal"
          data-bs-target="#newsAndEventsModal" (click)="getTheFeed();">
          <span class="nav-link mainlink">{{ 'HEADER.NEWSEVENTS' | translate }}</span>
        </button>
      </li>
      <li class="nav-item dropdown" role="tab">
        <span role="presentation" class="nav-link dropdown-toggle vx-cursor mainlink" id="dropdown0"
          data-bs-toggle="dropdown">{{ 'HEADER.FOLLOWUS' | translate }}</span>
        <div role="menu" class="dropdown-menu z-3" aria-labelledby="dropdown0">
          <a role="menuitem" class="dropdown-item" target="_blank"
            href="https://www.facebook.com/VeEX-Inc-105639244427066/">
            <i class="bi bi-facebook"></i>
            <span class="follow-link">{{ 'FOOTER.FACEBOOK' | translate }}</span>
          </a>
          <a role="menuitem" class="dropdown-item" target="_blank" href="https://www.instagram.com/veexinc/">
            <i class="bi bi-instagram"></i>
            <span class="follow-link">{{ 'FOOTER.INSTAGRAM' | translate }}</span>
          </a>
          <a role="menuitem" class="dropdown-item" target="_blank" href="https://www.linkedin.com/company/veexinc/">
            <i class="bi bi-linkedin"></i>
            <span class="follow-link">{{ 'FOOTER.LINKEDIN' | translate }}</span>
          </a>
          <a role="menuitem" class="dropdown-item" target="_blank" href="https://twitter.com/veexinc/">
            <i class="bi bi-twitter"></i>
            <span class="follow-link">{{ 'FOOTER.TWITTER' | translate }}</span>
          </a>
          <a role="menuitem" class="dropdown-item" target="_blank" href="https://www.youtube.com/user/VeEXinc/">
            <i class="bi bi-youtube"></i>
            <span class="follow-link">{{ 'FOOTER.YOUTUBE' | translate }}</span>
          </a>
        </div>
      </li>
      <li class="nav-item" role="presentation" [attr.data-bs-toggle]="isMobile ? 'collapse' : null"
        [attr.data-bs-target]="isMobile ? '#veexNavbar' : null">
        <button role="tab" type="button" class="header-button" data-bs-toggle="modal" data-bs-target="#corporateModal">
          <span class="nav-link mainlink">{{ 'HEADER.CORPORATE' | translate }}</span>
        </button>
      </li>
      <!-- <li class="nav-item" role="presentation">
        <button role="tab" type="button" class="header-button">
          <a class="nav-link mainlink" href="https://shop.veexinc.com/"
            target="_blank">{{ 'FOOTER.ONLINESHOP' | translate }}</a>
        </button>
      </li> -->
    </ul>

    <!-- Right Side -->
    <ul class="navbar-nav ms-auto" role="tablist">
      <li class="nav-item me-2 rightnav" role="tab" [attr.data-bs-toggle]="isMobile ? 'collapse' : null"
        [attr.data-bs-target]="isMobile ? '#veexNavbar' : null">
        <button type="button" class="header-button" data-bs-toggle="modal" data-bs-target="#myveexModal">
          <a class="nav-link mainlink" id="myveex" (click)="loadLogin();">MyVeEX</a>
        </button>
      </li>
      <!-- Search Field -->
      <li class="nav-item rightnav" role="tab">
        <form role="presentation" class="my-0 mainlink d-flex align-items-center" id="search-form"
          (submit)="submitSearch($event)">
          <div class="input-group py-1">
            <input type="search" class="form-control form-control-sm d-inline-block bg-secondary"
              placeholder="{{ 'BUTTON.SEARCH' | translate }} VeEX" aria-label="Search" id="searchsearch"
              [(ngModel)]="headersearch" name="headersearch" aria-describedby="search1">
            <button class="btn btn-outline-secondary btn-sm d-inline-block bg-secondary" type="button" id="search1"
              (click)="submitSearch($event)" aria-label="Search"><i class="bi bi-search text-white"></i></button>
          </div>
        </form>
      </li>
    </ul>
  </div>
</nav>
<div *ngIf="_router.url.split('?')[0] === '/'" class="vx-bg-primary text-center">
  <a class="text-white" queryParamsHandling="merge" routerLink="/connectorprotector">
    <p class="m-0 p-2">Extend Your Test Ports' Lifespan with the <span class="fw-bold">NEW</span> Optical Connector
      Protector System</p>
  </a>
</div>
<div *ngIf="_router.url.split('?')[0] === '/connectorprotector'" class="vx-bg-primary text-center text-white">
  <a class="text-white" queryParamsHandling="merge" routerLink="/company/contactus" [queryParams]="{ issue: 'sales', comments: 'connectorprotector' }">
    <p class="m-0 p-2">Contact Us About Getting Your Connector Protector Today!</p>
  </a>
</div>
<!-- <div class="fw-normal d-none d-md-block border vx-bg-primary p-1"
  id="fixedform" style="max-width: 50vw;">
  <app-nested-floating-form></app-nested-floating-form>
</div> -->
<!-- <div class="fw-normal d-none d-md-block border vx-bg-primary p-1" id="fixedbutton">
  <span class="vx-cursor text-white stretched-link small" (click)='scroll(target)'>{{ 'HEADER.BACKTOTOP' | translate }}
    <i class="bi bi-caret-up-fill"></i></span>
</div> -->
<!-- Modal for MyVeEX -->
<div class="modal fade" id="myveexModal" tabindex="-1" role="dialog" aria-labelledby="myveexModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div *ngIf="(!_loginService.user.accepted)" class="modal-content">
      <div class='modal-header vx-bg-primary text-white'><span
          class='modal-title h5'>{{ 'LOGIN.SUBTITLE' | translate }}</span>
        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeloginmodal">
          
        </button> -->
      </div>
      <div class="modal-body">
        <div class="container-fluid row">
          <div class="col-12 col-lg-6">
            <form (submit)="loginButton()" id="LoginForm3" name="LoginForm3">
              <!-- ignore hubspot form -->
              <div class="row m-0">
                <span id="CollectedForms-1234"></span>
                <!-- <label for="amex4" style="display:none">AMEX</label> -->
                <input type="hidden" name="amex4" required="" value="" id="amex4" #amex4>
                <label for="cc-num" class="hidden d-none">credit card</label>
                <input name="cc-num" class="hidden d-none" required="" value="HubspotCollectedForms" id="cc-num">
              </div>
              <!-- ignore hubspot form -->
              <div class="row mb-3">
                <div class="col">
                  <input type="text" class="form-control border border-secondary text-dark w-100" name="custId"
                    id="custId" autocomplete="username" [(ngModel)]="custId" placeholder="Username">
                </div>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <input type="password" class="form-control border border-secondary text-dark w-100" id="password"
                    name="password" [(ngModel)]="password" placeholder="Password" autocomplete="current-password">
                </div>
              </div>
              <div class="row">
                <div class="col mb-3 d-inline align-top">
                  <div class='form-check form-switch'>
                    <input type='checkbox' id='defaultCheck' class='form-check-input' name="rememberme"
                      [(ngModel)]="rememberme">
                    <label for='defaultCheck' class='form-check-label'>{{ 'FORMS.REMEMBERME' | translate }}</label>
                  </div>
                </div>
                <div class="col mb-3">
                  <p data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a routerLink="/forgotpassword"
                      queryParamsHandling="merge" class="float-end text-end">{{ 'FORGOTPW.TITLE' | translate }}?</a></p>
                </div>
              </div>
              <div class="row align-items-start">
                <div class="col mb-3">
                  <button class="btn btn-primary rounded-pill px-4" type="submit" data-bs-toggle="collapse"
                    [disabled]="_httpService.api === false">{{ 'BUTTON.LOGIN' | translate }}</button>
                </div>
                <div class="col mb-3">
                  <div class="float-end text-end small text-body-secondary">{{ 'MISC.ACCOUNT' | translate }}
                    <p data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a routerLink="/register"
                        queryParamsHandling="merge">{{ 'REGISTER.TITLE' | translate }}</a>
                    </p>
                  </div>
                </div>
              </div>
              <div id="loginErrorMessage">
                <h5 class="message text-start text-danger small">{{error}}</h5>
                <h5 class="message text-start text-success small">{{success}}</h5>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="(_loginService.user.accepted)" class="modal-content">
      <div class='modal-header vx-bg-primary text-white'><span class='modal-title h5'>Welcome to MyVeEX</span></div>
      <div class="modal-body">
        <div class="container-fluid">
          <form id="veexForm1" name="veexForm1" action="https://my.veexinc.com/v-net/vexweb/CustLoginAction.do"
            method="POST" target="_blank">
            <input type="hidden" name="action" value="login">
            <input type="hidden" name="updateFlag" value="1">
            <input type="hidden" name="cd" value="{{cd}}">
            <input type="hidden" name="pd" value="{{pd}}">
            <div class="py-3">
              <button class="btn btn-primary rounded-pill px-4" type="submit" id="entermyveex1"
                [disabled]="_httpService.api === false"
                (click)="loginmyveex()">{{ 'BUTTON.CONTINUE' | translate }}</button>
              <button (click)="_loginService.logout()"
                class="btn btn-light rounded-pill ms-3 px-4">{{ 'BUTTON.LOGOUT' | translate }}</button>
            </div>
          </form>
        </div>
        <p>If you are having difficulties connecting, please visit <a href="https://my.veexinc.com/v-net/vexweb/"
            target="_blank">MyVeEX</a></p>
      </div>
    </div>
  </div>
</div>


<!-- Modal for Products -->
<div class="modal fade" id="productsModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container-fluid row">
          <div class="col-12 col-sm-12 col-lg-4 col-xl-4">
            <h5 class="h5 fw-bold">{{ 'PRODUCTHEADER.CATEGORIES.TITLE' | translate }}</h5>
            <ul class="list-unstyled">
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" [queryParams]="{ productcategory: 'fttxpon' }" queryParamsHandling="merge"
                  routerLink="/productcategory/fttxpon">
                  <h6>FTTx / PON</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" [queryParams]="{ productcategory: 'ethernet' }" queryParamsHandling="merge"
                  routerLink="/productcategory/ethernet">
                  <h6>{{ 'PRODUCTHEADER.CATEGORIES.ETH' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" [queryParams]="{ productcategory: 'fiberoptics' }" queryParamsHandling="merge"
                  routerLink="/productcategory/fiberoptics">
                  <h6>{{ 'PRODUCTHEADER.CATEGORIES.FIBER' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" [queryParams]="{ productcategory: 'transportmetrocore' }"
                  queryParamsHandling="merge" routerLink="/productcategory/transport">
                  <h6>{{ 'PRODUCTHEADER.CATEGORIES.TRANMETCOR' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" [queryParams]="{ productcategory: 'wifi' }" queryParamsHandling="merge"
                  routerLink="/productcategory/wifi">
                  <h6>{{ 'PRODUCTHEADER.CATEGORIES.WIFI' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" [queryParams]="{ productcategory: 'dsl' }" queryParamsHandling="merge"
                  routerLink="/productcategory/dsl">
                  <h6>{{ 'PRODUCTHEADER.CATEGORIES.DSLCOP' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" [queryParams]="{ productcategory: 'catv' }" queryParamsHandling="merge"
                  routerLink="/productcategory/catv">
                  <h6>{{ 'PRODUCTHEADER.CATEGORIES.CATV' | translate }}</h6>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-sm-12 col-lg-3 col-xl-3">
            <h5 class="h5 fw-bold">{{ 'PRODUCTHEADER.SYSMONWORKMAN.TITLE' | translate }}</h5>
            <ul class="list-unstyled">
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/products/fiberizer"
                  [queryParams]="{ product: 'Fiberizer®' }">
                  <h6>{{ 'PRODUCTHEADER.SYSMONWORKMAN.FIBERIZER' | translate }}<span class="smaller">®</span></h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/noapp"
                  [queryParams]="{ product: 'NoApp' }">
                  <h6>NoApp<span class="smaller">®</span></h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/testwithflow"
                  [queryParams]="{ product: 'TestWithFlow' }">
                  <h6>{{ 'SOFTWARE.TESTWITHFLOW.TESTWITHFLOW' | translate }}<span class="smaller">®</span></h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/veexpress"
                  [queryParams]="{ product: 'VeExpress™' }">
                  <h6>{{ 'PRODUCTHEADER.SYSMONWORKMAN.VEEXPRESS' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/server/vesion"
                  [queryParams]="{ product: 'VeSion®' }">
                  <h6>{{ 'PRODUCTHEADER.SYSMONWORKMAN.VESION' | translate }}<span class="smaller">®</span></h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/server/rserver"
                  [queryParams]="{ product: 'VeSion® R-Server' }">
                  <h6>{{ 'PRODUCTHEADER.SYSMONWORKMAN.VESION' | translate }}<span class="smaller">®</span>
                    {{ 'PRODUCTHEADER.SYSMONWORKMAN.RSERVER' | translate }}</h6>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-sm-12 col-lg-3 col-xl-2">
            <h5 class="h5 fw-bold">{{ 'PRODUCTHEADER.TOOLS.TITLE' | translate }}</h5>
            <ul class="list-unstyled">
              <!-- <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                  <a class="product-item" routerLink="/menu/productcategories" >
                    <h6>Product Categories</h6>
                  </a>
                </li> -->
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/products">
                  <h6>{{ 'LANDING.PRODFINDTILE' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="modal" data-bs-target="#productlistmodal" data-bs-dismiss="modal"
                (click)="clickProductLoad();">
                <span class="product-item vx-cursor">
                  <h6>{{ 'PRODUCTHEADER.TOOLS.PRODUCTLIST' | translate }}</h6>
                </span>
              </li>
              <li class="product-list" data-bs-toggle="modal" data-bs-target="#otherproductlistModal"
                data-bs-dismiss="modal" (click)="clickPrevProductLoad();">
                <span class="product-item vx-cursor">
                  <h6>{{ 'PRODUCTHEADER.TOOLS.PREVIOUS' | translate }}</h6>
                </span>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item vx-cursor" queryParamsHandling="merge" routerLink="/menu/productlist">
                  <h6>{{ 'PRODUCTHEADER.TOOLS.FULLPRODLLIST' | translate }}</h6>
                </a>
              </li>
            </ul>
            <h5 class="h5 fw-bold">{{ 'FOOTER.APPS' | translate }}</h5>
            <ul class="list-unstyled">
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/apps"
                  [queryParams]="{ product: 'Apps' }">
                  <img src="assets/images/images/veexinc_apps.png" loading="lazy" width="72" height="72">
                </a>
              </li>
            </ul>
          </div>

          <div class="col-2 d-none d-xl-block justify-content-center">
            <app-nested-sidebar-product-catalog></app-nested-sidebar-product-catalog>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal for A-Z Products -->
<div class="modal fade" id="productlistmodal" tabindex="-1" role="dialog" aria-labelledby="productlistmodalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-xl w-100 modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col text-start">
              <li class="product-list" data-bs-toggle="modal" data-bs-target="#productsModal">
                <span class="product-item small vx-cursor">
                  &lt; {{ 'BUTTON.PREV' | translate }}</span> </li>
            </div>
            <div class="col text-center">
              <h5 class="h5 fw-bold" id="productlistmodalLabel">
                {{ 'PRODUCTHEADER.TOOLS.FULLPRODLLIST' | translate }}</h5>
            </div>
            <div class="col text-end">
              <a class="product-item small vx-cursor" queryParamsHandling="merge"
                routerLink="/menu/productlist">{{ 'PRODUCTHEADER.TOOLS.FULLPRODLLIST' | translate }} ></a>
            </div>
          </div>
          <ul *ngIf="productcards" class="section border list-unstyled card-columns p-1">
            <li *ngFor="let product of productcards" class="list-item p-0" data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show" data-bs-dismiss="modal">
              <a class="dropdown-item small" queryParamsHandling="merge" [routerLink]='product.link'
                [queryParams]="{ product: product.title }">{{ product.title }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal for other A-Z Products -->
<div class="modal fade" id="otherproductlistModal" tabindex="-1" role="dialog"
  aria-labelledby="otherproductlistModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl w-100 modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col text-start">
              <li class="product-list" data-bs-toggle="modal" data-bs-target="#productsModal">
                <span class="product-item small vx-cursor">
                  &lt; {{ 'BUTTON.PREV' | translate }}</span> </li>
            </div>
            <div class="col text-center">
              <h5 class="h5 fw-bold" id="otherproductlistModalLabel">
                {{ 'PRODUCTHEADER.TOOLS.PREVIOUS' | translate }}</h5>
            </div>
            <div class="col text-end">
              <a class="product-item small vx-cursor" queryParamsHandling="merge"
                routerLink="/menu/productlist">{{ 'PRODUCTHEADER.TOOLS.FULLPRODLLIST' | translate }} ></a>
            </div>
          </div>
          <ul *ngIf="previousproductcards" class="section border list-unstyled card-columns p-1 mb-0">
            <li *ngFor="let product of previousproductcards" class="dropdown-item small" data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show" data-bs-dismiss="modal">
              <a queryParamsHandling="merge" [routerLink]='product.link'
                [queryParams]="{ product: product.title }">{{ product.title }}</a>
              <p class="m-0"><span *ngIf="product.replaced" class="text-danger">
                  ({{ 'BADGE.REPLACED' | translate }}&nbsp;
                  <a queryParamsHandling="merge" [routerLink]="product.replacedlink"
                    [queryParams]="{ product: product.replaced }">{{ product.replaced }}</a>)
                </span>
              </p>
            </li>
          </ul>
          <div class="text-end">
            <a class="product-item small vx-cursor align-bottom" queryParamsHandling="merge"
              routerLink='/support/discontinuedproducts'>{{ 'DISCONTINUEDPROD.TITLE' | translate }} ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal for Solutions -->
<div class="modal fade" id="solutionsModal" tabindex="-1" role="dialog" aria-labelledby="solutionsModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container-fluid row">
          <div class="col-12 col-sm-12 col-lg-4">
            <h5 class="h5 fw-bold" id="solutionsModalLabel">Solutions Microsites</h5>
            <ul class="list-unstyled">
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/solutions/fiber">
                  <h6>{{ 'SOLUTIONSMICRO.FIBER' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge"
                  routerLink="/solutions/800g-400g-testing-the-future-of-communications">
                  <h6>{{ 'SOLUTIONSMICRO.400G' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge"
                  routerLink="/solutions/cloud-based-asset-and-workflow-management-platform">
                  <h6>{{ 'SOLUTIONSMICRO.ASSET' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge"
                  routerLink="/solutions/daa-and-r-phy-ready-test-solutions">
                  <h6>{{ 'SOLUTIONSMICRO.DAARPHY' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/solutions/docsis31">
                  <h6>{{ 'SOLUTIONSMICRO.DOCSIS' | translate }} {{ 'SOLUTIONSMICRO.DOCSIS1' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/solutions/wifi-testing">
                  <h6>{{ 'SOLUTIONSMICRO.WIFI' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/connectorprotector">
                  <h6>Optical Connector Protector System</h6>
                </a>
              </li>
            </ul>
          </div>
          <div *ngIf="microsite1url" class="col-lg-4 col-xl-4 d-none d-lg-block">
            <div class="card vx-shadow-hover h-100"><img class="card-img-top"
                src="assets/images/header/400G_Solutions_Landing.webp" alt="" title="" loading="lazy">
              <div class="card-body d-flex flex-column pt-2 pb-2">
                <div class="d-flex justify-content-center py-1">{{ 'SOLUTIONSMICRO.FLYER' | translate }}</div>
              </div>
              <div class="card-footer p-0 border-0 bg-white">
                <div class="text-center btn-green w-100">
                  <a class="py-2 text-white vx-cursor stretched-link" aria-label="Download 400G Test Solutions Flyer"
                    href="{{ microsite1url }}" tabindex="-1" target="_blank">{{ 'BUTTON.DOWNLOAD' | translate }}</a>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="microsite2url" class="col-xl-4 d-none d-xl-block">
            <div class="card vx-shadow-hover h-100"><img class="card-img-top"
                src="assets/images/header/daa-and-r-phy-test-solutions-headerimg.webp" alt="" title="" loading="lazy">
              <div class="card-body d-flex flex-column pt-2 pb-2">
                <div class="d-flex justify-content-center py-1">{{ 'SOLUTIONSMICRO.BROCHURE' | translate }}</div>
              </div>
              <div class="card-footer p-0 border-0 bg-white">
                <div class="text-center btn-green w-100">
                  <a class="py-2 text-white vx-cursor stretched-link"
                    aria-label="Download DAA and R-PHY Test Solutions Brochure" href="{{ microsite2url }}" tabindex="-1"
                    target="_blank">{{ 'BUTTON.DOWNLOAD' | translate }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal for Support -->
<div class="modal fade" id="supportModal" tabindex="-1" role="dialog" aria-labelledby="supportModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container-fluid row">
          <div class="col-12 col-sm-12 col-lg-3">
            <h5 class="h5 fw-bold" id="supportModalLabel">{{ 'FOOTER.SUPPORT' | translate }}</h5>
            <ul class="list-unstyled">
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/company/contactus">
                  <h6>{{ 'FOOTER.CONTACTUS' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/support/discontinuedproducts">
                  <h6>{{ 'DISCONTINUEDPROD.TITLE' | translate }}</h6>
                </a>
              </li>
              <!-- <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/company/financing">
                  <h6>{{ 'FOOTER.FINANCING' | translate }}</h6>
                </a>
              </li> -->
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" [queryParams]="{ comments: null }" routerLink="/i">
                  <h6>{{ 'BUTTON.DOWNLOAD' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" href="https://kb.veexinc.com/en/knowledge" target="_blank">
                  <h6>{{ 'FOOTER.KNOWLEDGEBASE' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/support/productregistration">
                  <h6>{{ 'FOOTER.PRODUCTREG' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" href="https://resources.veexinc.com" target="_blank">
                  <h6>Resources</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/support/rmarequest">
                  <h6>{{ 'FOOTER.RMAREQ' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/support/software">
                  <h6>{{ 'FOOTER.SWUPDATE' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/support/supportbulletins">
                  <h6>{{ 'FOOTER.SUPPORTBULLETIN' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge"
                  routerLink="/support/end-of-life-eol-policy-statement">
                  <h6>End of Life (EOL) Policy</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/support/warranty">
                  <h6>{{ 'FOOTER.WARRANTY' | translate }}</h6>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-sm-12 col-lg-9">
            <div class="card h-100">
              <div class="card-header py-2">Overview
              </div>
              <div class="card-body fw-normal py-2">
                <p>
                  VeEX<span class="small">®</span> {{ 'HEADER.SUPPORTOVERVIEW' | translate }}</p>
                <p>
                  Contact Customer Care for technical assistance: <br>
                  E-mail: <a routerLink="/company/contactus"
                    [queryParams]="{ issue: 'customercare', comments: 'question' }" queryParamsHandling="merge"
                    class="vx-cursor">customercare&#64;veexinc.com</a><br>
                  Call: +1.510.651.0500<br>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal for News and Events -->
<div class="modal fade" id="newsAndEventsModal" tabindex="-1" role="dialog"
  aria-labelledby="newsAndEventsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container-fluid row">
          <div class="col-12 col-sm-12 col-lg-3">
            <h5 class="h5 fw-bold" id="newsAndEventsModalLabel">{{ 'HEADER.NEWSEVENTS' | translate }}</h5>
            <ul class="list-unstyled">
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/newsandevents/events">
                  <h6>{{ 'FOOTER.EVENTS' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/newsandevents/multimedia">
                  <h6>{{ 'FOOTER.MULTIMEDIA' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/newsandevents/press-releases">
                  <h6>{{ 'FOOTER.PRESSRELEASES' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/newsandevents/webinars">
                  <h6>{{ 'FOOTER.WEBINARS' | translate }}</h6>
                </a>
              </li>
            </ul>
          </div>
          <div *ngIf="rssfeed" class="col-md-8 col-lg-9 col-xl d-none d-lg-block">
            <div class="card h-100">
              <div class="card-header py-2">Latest News
              </div>
              <div class="card-body fw-normal p-0">
                <ul class="list-group">
                  <li class="list-group-item border-0 py-2" *ngFor="let news of rssfeed | slice:0:5; let i=index"><a
                      href="{{news.link}}" target="_blank">[{{news.date}}] {{ news.description }}</a></li>
                </ul>
              </div>
            </div>
          </div>
          <!-- <div *ngIf="event.link" class="col-xl-3 d-none d-xl-block">
              <div class="card vx-shadow-hover h-100">
                <div class="card-header text-center py-2">Save the Date
                </div>
                <div class="card-body d-flex flex-column p-0">
                  <div class="justify-content-center">
                    <a class="d-flex p-2" href="{{ event.link }}" target="_blank"><img
                        src="assets/images/NewsAndEvents/{{ event.imgsrc }}" class="w-100" alt="..."></a>
                  </div>
                </div>
                <div class="card-footer p-0 text-center">
                  <a class="small stretched-link" queryParamsHandling="merge" routerLink="/newsandevents/events"
                    >{{ event.description }}<br>{{ event.booth }}</a>
                </div>
              </div>
            </div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal for Corporate -->
<div class="modal fade" id="corporateModal" tabindex="-1" role="dialog" aria-labelledby="corporateModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container-fluid row">
          <div class="col-12 col-sm-12 col-lg-3">
            <h5 class="h5 fw-bold" id="corporateModalLabel">{{ 'FOOTER.CORPORATE' | translate }}</h5>
            <ul class="list-unstyled">
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/company/aboutus">
                  <h6>{{ 'FOOTER.ABOUTUS' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/company/awards">
                  <h6>{{ 'FOOTER.AWARDS' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/company/careers">
                  <h6>{{ 'FOOTER.CAREERS' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/company/locateapartner">
                  <h6>{{ 'FOOTER.LOCATEPARTNER' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/company/customers">
                  <h6>{{ 'FOOTER.CUSTOMERS' | translate }}</h6>
                </a>
              </li>
              <li class="product-list" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="product-item" queryParamsHandling="merge" routerLink="/company/regulationsandcompliance">
                  <h6>Regulations & Compliance</h6>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-sm-12 col-lg-9">
            <div class="card h-100">
              <div class="card-header py-2">{{ 'FOOTER.ABOUTUS' | translate }}
              </div>
              <div class="card-body fw-normal py-3">
                <p>{{ 'HEADER.ABOUT1' | translate }} </p>
                <p>{{ 'HEADER.ABOUT2' | translate }} </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
